/**
 * Japanese translations
 */

export default {
  'Not included': '含まれていない',
  Included: '含まれている',
  Refresh: '更新',
  Unlimited: '無制限',
  'Pricing plans': '料金プラン',
  'Select an option': 'オプションを選択する',
  'Play video': '動画を再生する',
  'Pause video': '動画を一時停止する',
  // Add more translations here
}
